import { Button } from "./Button";

export const componentsOverride = (theme) => ({
  ...Button(theme),
});
